import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-116c96e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-reports page-table" }
const _hoisted_2 = { class: "reports-menu-root bc-2 hide-print" }
const _hoisted_3 = {
  class: "calendar-controller",
  style: {"height":"auto"}
}
const _hoisted_4 = { class: "date" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "〜", -1))
const _hoisted_6 = { class: "date" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "actions hide-sp" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "page-table-body-wrapper hide-print" }
const _hoisted_12 = {
  class: "page-table-body page-reports-body",
  style: {"height":"calc(100vh - 114px)","overflow":"hidden"}
}
const _hoisted_13 = { style: {"height":"calc(100vh - 178px)","overflow":"auto"} }
const _hoisted_14 = {
  id: "tableHead",
  class: "table-head summary-table"
}
const _hoisted_15 = { class: "summary-table-header" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "table-body summary-table-body" }
const _hoisted_18 = { class: "show-print" }
const _hoisted_19 = { class: "page-table-body-wrapper" }
const _hoisted_20 = {
  class: "page-table-body page-reports-body",
  style: {"overflow":"hidden"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "〜", -1))
const _hoisted_22 = {
  id: "tableHead4Print",
  class: "table-head summary-table"
}
const _hoisted_23 = { class: "summary-table-header" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "table-body summary-table-body" }

import { computed, ref, onMounted } from 'vue'
import DatePicker from '@/components/common/DatePicker.vue'
import moment from 'moment'
import { useSummaryStore } from '@/stores/summaryStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { SummaryParams } from '@/repositories/summary-repository'
import { chunk } from 'lodash'
import CsvDownloader, { CsvData } from '@/lib/CsvDownloader'
import { ThresholdItem } from '@/models/Summary'
import Summary, { SummeryItem } from '@/models/Summary'

type SummaryWithOption = Summary & {
  name: string
  areaName: string
  areaCode: string
}

type Record = SummaryWithOption & {
  items: SummeryItem & {
    [x: string]: {
      isMax: string
    }
  }
  thresholdItems: ThresholdItem
}

type Rainfalls = {
  [areaCode: string]: (number | null | undefined)[]
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _startDateMoment = moment().add(-10, 'day').startOf('minutes')
const _endDateMoment = moment().startOf('minutes')

const summaryStore = useSummaryStore()
const initDataStore = useInitDataStore()
const startDate = ref(_startDateMoment.set('minutes', Math.floor(_startDateMoment.minutes() / 10) * 10).toDate())
const endDate = ref(_endDateMoment.set('minutes', Math.floor(_endDateMoment.minutes() / 10) * 10).toDate())
const currentDisplayingDate = {
  start: startDate.value,
  end: endDate.value,
}
const summary = ref<SummaryWithOption[]>([])
const loading = ref(false)
const REPORT_TYPES = {
  TEN_MIN: 'ten_min',
}
const REPORT_TYPE_RESOLUTION = {
  [REPORT_TYPES.TEN_MIN]: 'ten_min',
}
const resolution = computed(() => {
  return REPORT_TYPE_RESOLUTION[REPORT_TYPES.TEN_MIN]
})
const headers = [
  '局名',
  '区分',
  '10分間最大雨量<br>(mm)',
  '区内<br>最大値',
  '集計時刻',
  '1時間最大雨量<br>(mm)',
  '区内<br>最大値',
  '集計時刻',
  '総雨量<br>(mm)',
  '区内<br>最大値',
  '降雨時間',
]
const FILENAME_TEMPLATE = '雨量期間統計_{startTime}～{endTime}.{ext}'

const search = async () => {
  const startTime = moment(startDate.value)
  const endTime = moment(endDate.value)
  if (startTime.isAfter(endTime, 'minutes')) {
    alert('開始時刻が終了時刻より未来の設定です')
    return
  } else if (10 < endTime.diff(startTime.clone().startOf('days'), 'days')) {
    alert('取得範囲は10日間以内に設定してください')
    return
  }
  currentDisplayingDate.start = startDate.value
  currentDisplayingDate.end = endDate.value

  loading.value = true

  summary.value = []
  for (const item of initDataStore.initData.definitionInfo.summary.items.rain.items) {
    const params: SummaryParams = {
      stationId: item.stationId,
      target: ['max_move_rain_min_10', 'move_rain_min_60', 'rain_min_10'],
      range: {
        startTime: startTime.format(),
        endTime: endTime.format(),
        type: 'hour',
      },
      threshold: [
        {
          key: 'rain_time',
          operation: 'gt',
          target: 'rain_min_10',
          comparison_value: 0,
        },
      ],
    }
    const res = await summaryStore.fetch(params)
    summary.value.push({
      ...item,
      ...res,
    })
  }

  loading.value = false
}

const records = computed<Record[]>((): Record[] => {
  const result = summary.value as Record[]

  if (loading.value) {
    return result
  }

  // 区間最大値の算出
  const maxMoveRainMin10MaxList: Rainfalls = {}
  const moveRainMin60MaxList: Rainfalls = {}
  const rainMin10SumList: Rainfalls = {}
  result.forEach(v => {
    if (!Object.keys(maxMoveRainMin10MaxList).includes(v.areaCode)) {
      maxMoveRainMin10MaxList[v.areaCode] = []
    }
    if (!Object.keys(moveRainMin60MaxList).includes(v.areaCode)) {
      moveRainMin60MaxList[v.areaCode] = []
    }
    if (!Object.keys(rainMin10SumList).includes(v.areaCode)) {
      rainMin10SumList[v.areaCode] = []
    }
    v.items.rainMin10.sum =
      v.thresholdItems.rainTime &&
      !Object.keys(v.thresholdItems.rainTime).length &&
      v.items.maxMoveRainMin10.max == null
        ? null
        : v.items.rainMin10.sum
    maxMoveRainMin10MaxList[v.areaCode].push(v.items.maxMoveRainMin10.max)
    moveRainMin60MaxList[v.areaCode].push(v.items.moveRainMin60.max)
    rainMin10SumList[v.areaCode].push(v.items.rainMin10.sum)
  })

  let maxMoveRainMin10MaxMax = 0
  let moveRainMin60MaxMax = 0
  let rainMin10SumMax = 0
  Object.keys(maxMoveRainMin10MaxList).forEach(areaCode => {
    maxMoveRainMin10MaxMax = Math.max(
      ...maxMoveRainMin10MaxList[areaCode].filter<number>((v): v is number => v !== void 0 && v !== null)
    )
    moveRainMin60MaxMax = Math.max(
      ...moveRainMin60MaxList[areaCode].filter<number>((v): v is number => v !== void 0 && v !== null)
    )
    rainMin10SumMax = Math.max(
      ...rainMin10SumList[areaCode].filter<number>((v): v is number => v !== void 0 && v !== null)
    )
    result.forEach(record => {
      if (record.areaCode === areaCode) {
        record.items.maxMoveRainMin10.isMax = record.items.maxMoveRainMin10.max === maxMoveRainMin10MaxMax ? '▲' : ''
        record.items.moveRainMin60.isMax = record.items.moveRainMin60.max === moveRainMin60MaxMax ? '★' : ''
        record.items.rainMin10.isMax = record.items.rainMin10.sum === rainMin10SumMax ? '◆' : ''
      }
    })
  })

  return result
})

const downloadCsv = () => {
  const fileName = getFilename('csv')
  const csvHeaders = [
    [
      moment(currentDisplayingDate.start).format('YYYY年MM月DD日 HH:mm'),
      '〜',
      moment(currentDisplayingDate.end).format('YYYY年MM月DD日 HH:mm'),
    ],
    headers.map(header => header.replaceAll('<br>', '')),
  ]
  const csvBodies = [] as string[][]
  records.value.forEach(record => {
    const maxMoveRainMin10MaxTime = record.items.maxMoveRainMin10.maxTime
      ? moment(record.items.maxMoveRainMin10.maxTime).format('YYYY年MM月DD日 HH:mm')
      : ''
    const moveRainMin60MaxTime = record.items.moveRainMin60.maxTime
      ? moment(record.items.moveRainMin60.maxTime).format('YYYY年MM月DD日 HH:mm')
      : ''
    const startTime = record.thresholdItems.rainTime.startTime
      ? moment(record.thresholdItems.rainTime.startTime).format('YYYY年MM月DD日 HH:mm')
      : ''
    const endTime = record.thresholdItems.rainTime.endTime
      ? moment(record.thresholdItems.rainTime.endTime).format('YYYY年MM月DD日 HH:mm')
      : ''

    const row = []
    row.push(record.name)
    row.push(record.areaName)
    row.push(formatRainfall(record.items.maxMoveRainMin10.max))
    row.push(record.items.maxMoveRainMin10.isMax)
    row.push(maxMoveRainMin10MaxTime)
    row.push(formatRainfall(record.items.moveRainMin60.max))
    row.push(record.items.moveRainMin60.isMax)
    row.push(moveRainMin60MaxTime)
    row.push(formatRainfall(record.items.rainMin10.sum))
    row.push(record.items.rainMin10.isMax)
    row.push(startTime + ' 〜 ' + endTime)
    csvBodies.push(row)
  })
  const csvData = [...csvHeaders, ...csvBodies] as CsvData

  CsvDownloader.download(csvData, fileName)
}

const print = () => {
  const org = document.title
  document.title = getFilename('pdf')

  window.print()

  document.title = org
}

const chunkedRecords = computed(() => {
  return chunk(records.value, 10)
})

const getFilename = (extension: string) => {
  const startTime = moment(currentDisplayingDate.start)
  const endTime = moment(currentDisplayingDate.end)
  return FILENAME_TEMPLATE.replace('{startTime}', startTime.format('YYYYMMDDHHmm'))
    .replace('{endTime}', endTime.format('YYYYMMDDHHmm'))
    .replace('{ext}', extension)
}

const formatRainfall = (val?: number | null) => {
  return val !== null && val !== void 0 ? val.toFixed(1) : ''
}

onMounted(search)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(DatePicker, {
            modelValue: startDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
            resolution: _unref(resolution),
            "show-hour": true,
            "show-minutes": false
          }, null, 8, ["modelValue", "resolution"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(DatePicker, {
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
            resolution: _unref(resolution),
            "show-hour": true,
            "show-minutes": false
          }, null, 8, ["modelValue", "resolution"])
        ]),
        _createElementVNode("button", {
          class: "btn btn-submit hide-sp",
          onClick: search,
          disabled: loading.value
        }, "検索", 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: downloadCsv,
          class: "actions-item with-icon btn-csv",
          disabled: loading.value
        }, "CSV", 8, _hoisted_9),
        _createElementVNode("button", {
          onClick: print,
          class: "actions-item with-icon btn-print",
          disabled: loading.value
        }, "印刷", 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("table", _hoisted_14, [
            _createElementVNode("thead", _hoisted_15, [
              _createElementVNode("tr", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header, index) => {
                  return _createElementVNode("td", {
                    key: index,
                    innerHTML: header
                  }, null, 8, _hoisted_16)
                }), 64))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(records), (record, trIndex) => {
                return (_openBlock(), _createElementBlock("tr", { key: trIndex }, [
                  _createElementVNode("td", null, _toDisplayString(record.name), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, _toDisplayString(record.areaName), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(formatRainfall(record.items.maxMoveRainMin10.max)), 1),
                  _createElementVNode("td", null, _toDisplayString(record.items.maxMoveRainMin10.isMax), 1),
                  _createElementVNode("td", null, _toDisplayString(record.items.maxMoveRainMin10.maxTime
                      ? _unref(moment)(record.items.maxMoveRainMin10.maxTime).format('YYYY年MM月DD日 HH:mm')
                      : ''), 1),
                  _createElementVNode("td", null, _toDisplayString(formatRainfall(record.items.moveRainMin60.max)), 1),
                  _createElementVNode("td", null, _toDisplayString(record.items.moveRainMin60.isMax), 1),
                  _createElementVNode("td", null, _toDisplayString(record.items.moveRainMin60.maxTime
                      ? _unref(moment)(record.items.moveRainMin60.maxTime).format('YYYY年MM月DD日 HH:mm')
                      : ''), 1),
                  _createElementVNode("td", null, _toDisplayString(formatRainfall(record.items.rainMin10.sum)), 1),
                  _createElementVNode("td", null, _toDisplayString(record.items.rainMin10.isMax), 1),
                  _createElementVNode("td", null, _toDisplayString(record.thresholdItems.rainTime.startTime
                      ? _unref(moment)(record.thresholdItems.rainTime.startTime).format('YYYY年MM月DD日 HH:mm')
                      : '') + " 〜 " + _toDisplayString(record.thresholdItems.rainTime.endTime
                      ? _unref(moment)(record.thresholdItems.rainTime.endTime).format('YYYY年MM月DD日 HH:mm')
                      : ''), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedRecords), (data, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "page-break-after",
              style: {"overflow":"auto"},
              key: index
            }, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(_unref(moment)(currentDisplayingDate.start).format('YYYY年MM月DD日 HH:mm')), 1),
                _hoisted_21,
                _createElementVNode("span", null, _toDisplayString(_unref(moment)(currentDisplayingDate.end).format('YYYY年MM月DD日 HH:mm')), 1)
              ]),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("thead", _hoisted_23, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header, hIndex) => {
                      return _createElementVNode("td", {
                        key: hIndex,
                        innerHTML: header
                      }, null, 8, _hoisted_24)
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (record, trIndex) => {
                    return (_openBlock(), _createElementBlock("tr", { key: trIndex }, [
                      _createElementVNode("td", null, _toDisplayString(record.name), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, _toDisplayString(record.areaName), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(formatRainfall(record.items.maxMoveRainMin10.max)), 1),
                      _createElementVNode("td", null, _toDisplayString(record.items.maxMoveRainMin10.isMax), 1),
                      _createElementVNode("td", null, _toDisplayString(record.items.maxMoveRainMin10.maxTime
                        ? _unref(moment)(record.items.maxMoveRainMin10.maxTime).format('YYYY年MM月DD日 HH:mm')
                        : ''), 1),
                      _createElementVNode("td", null, _toDisplayString(formatRainfall(record.items.moveRainMin60.max)), 1),
                      _createElementVNode("td", null, _toDisplayString(record.items.moveRainMin60.isMax), 1),
                      _createElementVNode("td", null, _toDisplayString(record.items.moveRainMin60.maxTime
                        ? _unref(moment)(record.items.moveRainMin60.maxTime).format('YYYY年MM月DD日 HH:mm')
                        : ''), 1),
                      _createElementVNode("td", null, _toDisplayString(formatRainfall(record.items.rainMin10.sum)), 1),
                      _createElementVNode("td", null, _toDisplayString(record.items.rainMin10.isMax), 1),
                      _createElementVNode("td", null, _toDisplayString(record.thresholdItems.rainTime.startTime
                        ? _unref(moment)(record.thresholdItems.rainTime.startTime).format('YYYY年MM月DD日 HH:mm')
                        : '') + " 〜 " + _toDisplayString(record.thresholdItems.rainTime.endTime
                        ? _unref(moment)(record.thresholdItems.rainTime.endTime).format('YYYY年MM月DD日 HH:mm')
                        : ''), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})